// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.selfserveonboarding.RentalManagerUserSelfServiceOnboardingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface SubmitManualListingParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Path =
  '/api/web/v1/users/adManagement/selfServeOnboarding/submitManualListing';

/**
 * Submit manual self serve onboarding listing for review
 */
export const RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing = (
  getParams: SubmitManualListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SubmitManualListingParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
